const sentryIgnoredErrorName = '[sentry ignore]';
export function makeSentryIgnoredError(msg, displayMessage) {
    const err = new Error(msg);
    err.name = sentryIgnoredErrorName;
    if (displayMessage != null) {
        err.displayMessage = displayMessage;
    }
    return err;
}
export function isSentryIgnoredError(err) {
    return err != null && err.name === sentryIgnoredErrorName;
}
export function getDisplayMessage(err) {
    return typeof (err === null || err === void 0 ? void 0 : err.displayMessage) === 'string' ? err.displayMessage : undefined;
}
